import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";

import {
  updateFilteredRoomAvailabiltyArray,
  updateRoomRateEditable,
} from "../../../../reducer/bookingReducer";
import { Input } from "antd";
import useRoomDrawerLogic from "../../../../hooks/bookingCustomHook/useRoomDrawerLogic";
import { BiEdit } from "react-icons/bi";
import { BsSearch } from "react-icons/bs";
import IndiviualRoomDetail from "./IndiviualRoomDetail";

const EditRoomDetails = ({ mealPlanChanged }) => {
  const {
    roomRateEditable,
    roomAvailabiltyArray,
    filteredRoomAvailabilityArray,
    roomAvailabiltyError,
  } = useSelector((store) => store.booking);

  const { occupancyPlanRateLoading } = useSelector(
    (store) => (store) => store.login
  );

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    handleSearchText();
  }, [searchText]);

  const handleSearchText = () => {
    let currentArray = roomAvailabiltyArray?.filter((obj) =>
      obj?.name.toLowerCase().includes(searchText.toLowerCase())
    );
    dispatch(updateFilteredRoomAvailabiltyArray(currentArray));
  };

  useRoomDrawerLogic(setLoading, mealPlanChanged);
  return (
    <div
      className={` overflow-y-auto no-scrollbar   rounded-lg  mx-3 
         flex flex-col  h-[100%] mt-[17rem] no-scrollbar `}
    >
      <div className="inline-block min-w-full  rounded-lg">
        {loading || occupancyPlanRateLoading ? (
          <div className="w-[100%] flex justify-center items-center">
            <CircularProgress size={32} />
          </div>
        ) : (
          <div className="">
            <div
              style={{
                boxShadow: "0px 4px 12px 0px #6E829F14",
              }}
              className=" fixed right-[2rem] w-[750px] bg-[#F9FAFB]   rounded-t-[16px] 
              border-[#EAECF0] border-[1px] top-[8rem] h-[71px] 
              flex justify-between items-center"
            >
              {[
                { title: "Room Type", width: "20%" },
                { title: "Availability", width: "14%" },
                { title: "Room Rate", width: "20%" },
                { title: "Adult Count", width: "13%" },
                { title: "Child Count", width: "13%" },
                { title: "Quantity", width: "20%" },
              ]?.map((head, index) => {
                return (
                  <div
                    className={`w-[${head?.width}] p-[12px]  text-[#667085]  whitespace-nowrap
                    text-[14px] leading-[22.68px]  flex justify-center items-center font-outfit font-[500] `}
                    key={index}
                  >
                    {index === 0 ? (
                      <Input
                        prefix={
                          <BsSearch className="text-[#007FFF] font-[500]  pr-[5px] z-[20] text-[18px]" />
                        }
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="h-[36px] text-[#007FFF] w-[100%] border-[#007FFF] border-[1px] pl-[1rem] rounded-[32px] bg-[#F5F7FA] "
                        placeholder="Search Rooms"
                      />
                    ) : (
                      <div className="flex items-center text-[#8F9BB3]">
                        {head?.title}
                        {index === 2 && (
                          <BiEdit
                            className="ml-2 text-[#007FFF] cursor-pointer"
                            onClick={() =>
                              dispatch(
                                updateRoomRateEditable(!roomRateEditable)
                              )
                            }
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div
              className={` fixed  border-[#EAECF0] border-[1px] right-[2rem] w-[750px]  rounded-b-[16px]   flex flex-col  
              top-[11.8rem] max-h-[20rem] overflow-y-auto  `}
            >
              {roomAvailabiltyError ? (
                <div className=" rounded-b-xl bg-[#FFF] ">
                  <div className="cursor-default   px-6  py-4 text-[14px] text-[#F36960] ">
                    {typeof roomAvailabiltyError === "string"
                      ? roomAvailabiltyError
                      : ` No rooms available for the selected dates. Please choose
                    different dates for your stay.`}
                  </div>
                </div>
              ) : roomAvailabiltyArray?.length === 0 ? (
                <div className=" rounded-b-xl bg-[#FFF] ">
                  <div className="cursor-default   px-6  py-4 text-[14px] text-[#F36960] ">
                    No rooms available for the selected dates. Please choose
                    different dates for your stay.
                  </div>
                </div>
              ) : (
                filteredRoomAvailabilityArray?.map((roomData, index) => {
                  return <IndiviualRoomDetail roomTypeObj={roomData} />;
                })
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditRoomDetails;
